"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavMenuButton = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _theming = require("@storybook/theming");

var _designSystem = require("@storybook/design-system");

var _styles = require("../shared/styles");

var _excluded = ["active", "inverse", "monochrome", "open", "children"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var ExpandableIcon = ( /*#__PURE__*/0, _theming.styled)(_designSystem.Icon, process.env.NODE_ENV === "production" ? {
  target: "e3fogq21"
} : {
  target: "e3fogq21",
  label: "ExpandableIcon"
})(process.env.NODE_ENV === "production" ? {
  name: "11v8wyq",
  styles: "margin-left:5px;margin-right:0;width:10px;height:10px"
} : {
  name: "11v8wyq",
  styles: "margin-left:5px;margin-right:0;width:10px;height:10px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var PureNavMenuButton = (0, _theming.styled)("button", process.env.NODE_ENV === "production" ? {
  target: "e3fogq20"
} : {
  target: "e3fogq20",
  label: "PureNavMenuButton"
})(_styles.text.regularBold, ";display:inline-flex;align-items:center;text-align:center;padding:6px 8px;color:", function (props) {
  return props.inverse ? _styles.color.lightest : _styles.color.dark;
}, ";text-decoration:none;border-radius:", _styles.spacing.borderRadius.small, "px;background-color:transparent;transition:background-color 150ms ease-out,color 150ms ease-out;outline:0;border:0;cursor:pointer;", function (props) {
  return props.active && /*#__PURE__*/(0, _theming.css)("color:", props.monochrome ? _styles.color.lightest : _styles.color.secondary, ";background-color:", props.monochrome ? 'rgba(255, 255, 255, 0.14)' : 'rgba(30, 167, 253, 0.07)', ";" + (process.env.NODE_ENV === "production" ? "" : ";label:PureNavMenuButton;"));
}, ";", function (props) {
  return props.open && props.monochrome && /*#__PURE__*/(0, _theming.css)("color:", _styles.color.lightest, ";background-color:rgba(255, 255, 255, 0.14);" + (process.env.NODE_ENV === "production" ? "" : ";label:PureNavMenuButton;"));
}, ";", function (props) {
  return props.open && !props.monochrome && /*#__PURE__*/(0, _theming.css)("color:", _styles.color.secondary, ";background-color:rgba(30, 167, 253, 0.14);" + (process.env.NODE_ENV === "production" ? "" : ";label:PureNavMenuButton;"));
}, ";", function (props) {
  return props.monochrome ? /*#__PURE__*/(0, _theming.css)("&:hover,&:focus,&:focus-within{color:", _styles.color.lightest, ";background-color:rgba(255, 255, 255, 0.14);}&:active{color:", _styles.color.lightest, ";background-color:rgba(255, 255, 255, 0.07);}" + (process.env.NODE_ENV === "production" ? "" : ";label:PureNavMenuButton;")) : /*#__PURE__*/(0, _theming.css)("&:hover,&:focus,&:focus-within{color:", _styles.color.secondary, ";background-color:rgba(30, 167, 253, 0.14);}&:active{color:", _styles.color.secondary, ";background-color:rgba(30, 167, 253, 0.07);}" + (process.env.NODE_ENV === "production" ? "" : ";label:PureNavMenuButton;"));
}, ";");
var NavMenuButton = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var active = _ref.active,
      inverse = _ref.inverse,
      monochrome = _ref.monochrome,
      open = _ref.open,
      children = _ref.children,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(PureNavMenuButton, (0, _extends2["default"])({
    active: active,
    inverse: inverse,
    monochrome: monochrome,
    ref: ref,
    open: open
  }, props), children, open ? /*#__PURE__*/_react["default"].createElement(ExpandableIcon, {
    icon: "arrowup"
  }) : /*#__PURE__*/_react["default"].createElement(ExpandableIcon, {
    icon: "arrowdown"
  }));
});
exports.NavMenuButton = NavMenuButton;
NavMenuButton.displayName = 'NavMenuButton';